import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StipendRequest, StipendRequest_DTO } from '@models/request';
import { mapStipendRequest_DTO_To_StipendRequest } from '@services/transforms/request-transform';
import { convertToFormData } from '@utility/formData-util';
import { getSiteBaseUrl, isInProcessOrHigher_PaymentRequest, SaveStatusResponse } from '@utility/utility';
import { BehaviorSubject, map, shareReplay, switchMap, tap } from 'rxjs';

@Injectable({
    providedIn: 'any', // must be provided page-wise, not a singleton, because it provides state that should be cleared page changes
})
export class StipendRequestService {
    private http = inject(HttpClient);
    private readonly subject = new BehaviorSubject<StipendRequest | undefined>(undefined);
    public readonly state$ = this.subject.asObservable(); //.pipe(skip(1), shareReplay(1));
    public readonly isInProcessOrHigher$ = this.state$.pipe(
        map((request) => {
            if (!request) return null;
            return isInProcessOrHigher_PaymentRequest(request.status?.statusId);
        }),
        shareReplay(1)
    );

    get(requestId: number) {
        return this.http.get<StipendRequest_DTO>(`${getSiteBaseUrl()}/api/requests/stipend/${requestId}`).pipe(
            map((dto) => mapStipendRequest_DTO_To_StipendRequest(dto)),
            tap((request) => this.subject.next(request))
        );
    }
    getStateValue() {
        return this.subject.getValue();
    }

    set(request: StipendRequest): void {
        this.subject.next(request);
    }

    clearState() {
        this.subject.next(undefined);
    }
    create(request: StipendRequest) {
        const formData = convertToFormData(request);
        return this.http.post<SaveStatusResponse>(`${getSiteBaseUrl()}/api/requests/stipend`, formData);
    }

    update(requestId: number, request: StipendRequest) {
        // const formData = convertToFormData(request);
        return this.http.put<SaveStatusResponse>(`${getSiteBaseUrl()}/api/requests/stipend`, request).pipe(
            switchMap(() => {
                return this.get(requestId);
            })
        );
    }
}
